import { render, staticRenderFns } from "./main-form.vue?vue&type=template&id=1ce2568e&scoped=true"
import script from "./main-form.vue?vue&type=script&lang=js"
export * from "./main-form.vue?vue&type=script&lang=js"
import style0 from "./main-form.vue?vue&type=style&index=0&id=1ce2568e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce2568e",
  null
  
)

export default component.exports